import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import React from "react";
import { Controller, useForm } from "react-hook-form";

import { CustomButton } from "../../../scripts/components/renewal_v1/button";
import { CustomForm } from "../../../scripts/components/renewal_v1/form";
import { TextLink } from "../../../scripts/components/renewal_v1/text_link";
import { EntranceTemplate } from "../../../scripts/template/EntranceTemplate";
import theme from "../../../theme";
import {
  EMAIL_FORMAT_MESSAGE,
  EMAIL_MAX_LENGTH_MESSAGE,
  EMAIL_REGEX,
  EMAIL_REQUIRED_MESSAGE,
  MAX_EMAIL_LENGTH,
} from "../../../utilities/renewal_v1/const";

import { useSendPasswordResetLink } from "./hooks/useResetPassword";

export const SendPasswordRestLinkPage: React.FC = () => {
  const { sendPasswordResetLink, loading, error } = useSendPasswordResetLink();
  const { handleSubmit, errors, control } = useForm();

  return (
    <EntranceTemplate title="パスワードリセット">
      <Box mt={4}>
        <form onSubmit={handleSubmit(sendPasswordResetLink)}>
          <Box display="flex" flexDirection="column" style={{ gap: theme.spacing(2) }}>
            <Box textAlign="left">
              <Typography variant="body2" color="textSecondary">
                ご登録のメールアドレスにパスワードリセットのリンクをお送りします。
              </Typography>
            </Box>
            <Box textAlign="left">
              <Controller
                name="email"
                control={control}
                defaultValue={""}
                rules={{
                  required: EMAIL_REQUIRED_MESSAGE,
                  maxLength: {
                    value: MAX_EMAIL_LENGTH,
                    message: EMAIL_MAX_LENGTH_MESSAGE,
                  },
                  pattern: {
                    value: EMAIL_REGEX,
                    message: EMAIL_FORMAT_MESSAGE,
                  },
                }}
                render={({ ...field }) => (
                  <CustomForm
                    {...field}
                    label="メールアドレス"
                    type="text"
                    autoComplete="email"
                    error={!!errors.email}
                    errorText={Boolean(errors.email) && errors.email.message}
                    placeHolder="propally@gmail.com"
                  />
                )}
              />
              {error && (
                <Box color="secondary.main" mb={3}>
                  {error}
                </Box>
              )}
            </Box>

            <CustomButton type="submit" customVariant="filled" fullWidth disabled={loading}>
              メール送信
            </CustomButton>
            <Box my={3} textAlign="center">
              <Box mb={2}>
                <TextLink href="/login" underline>
                  ログインに戻る
                </TextLink>
              </Box>
              <Typography variant="body2">
                何か問題が発生している場合は <br />
                <TextLink href="https://form.run/@propally-1619963249" targetBlank>
                  <Typography variant="body2" component="span" color="primary">
                    こちら
                  </Typography>
                  <Typography variant="body2" component="span">
                    からご報告ください
                  </Typography>
                </TextLink>
              </Typography>
            </Box>
          </Box>
        </form>
      </Box>
    </EntranceTemplate>
  );
};
